import { render, staticRenderFns } from "./ed-settings-menu.component.vue?vue&type=template&id=415493a9&scoped=true&"
import script from "./ed-settings-menu.component.ts?vue&type=script&lang=ts&"
export * from "./ed-settings-menu.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-settings-menu.component.scss?vue&type=style&index=0&id=415493a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415493a9",
  null
  
)

export default component.exports